<template>
  <div class="app-container">
    <div
      class="map"
      @mousewheel="rollImg($event)"
      @DOMMouseScroll="rollImg($event)"
      ref="mapScroll"
    >
      <vue-drag-resize
        :isResizable="false"
        :style="{
          width: mapWidth + 'px',
          height: mapHeight + 'px',
          position: 'relative',
          zoom: mapZoom + '%',
          '-moz-transform-origin': 'top left',
          '-moz-transform': 'scale(' + mapZoom / 100 + ')',
        }"
      >
        <template>
          <el-image :src="img" ref="mapBackGround" :style="{ cursor: 'move' }">
            <div slot="placeholder" class="no-data">
              {{ $t("map.loading") }}<span class="dot">...</span>
            </div>
          </el-image>
        </template>
        <template v-for="(item, i) in fireTipData">
          <div
            ref="tip"
            :key="i"
            class="tip"
            @click="go(item.registerCode, item.title)"
          >
            <div class="v-tooltip">
              {{ item.title }}
              <span class="el-icon-caret-bottom"></span>
            </div>
            <img width="28px" :src="require('@/assets/images/lift.png')" />
          </div>
        </template>
      </vue-drag-resize>
    </div>
    <v-dialog
      :deviceEui="deviceEui"
      :registerCode="registerCode"
      :title="title"
      :elevatorDialogVisible.sync="elevatorDialogVisible"
    />
  </div>
</template>

<script>
import VDialog from './v-dialog'

export default {
  components: {
    VDialog
  },
  data() {
    return {
      img: require("@/assets/bg/bg1.jpg"),
      mapWidth: 1600,
      mapHeight: 900,
      mapZoom: 100,
      minZoom: 50,
      maxZoom: 200,
      deviceInfo: {},
      fireTipData: [
        {
          title: "大裙楼右侧电梯",
          registerCode: "31104205002020103326",
          handNewspaperNum: 0,
          handNewspaperSum: 126,
          detectorNum: 0,
          detectorSum: 176,
        },
        {
          title: "大裙楼左侧电梯",
          registerCode: "31104205002020103327",
          handNewspaperNum: 0,
          handNewspaperSum: 126,
          detectorNum: 0,
          detectorSum: 176,
        },
        {
          title: "1#客梯",
          registerCode: "31104205002020103319",
          handNewspaperNum: 0,
          handNewspaperSum: 126,
          detectorNum: 0,
          detectorSum: 176,
        },
        {
          title: "2#客梯",
          registerCode: "31104205002020103320",
          handNewspaperNum: 0,
          handNewspaperSum: 126,
          detectorNum: 0,
          detectorSum: 176,
        },
        {
          title: "3#客梯",
          registerCode: "31104205002020103321",
          handNewspaperNum: 0,
          handNewspaperSum: 126,
          detectorNum: 0,
          detectorSum: 176,
        },
        {
          title: "4#客梯",
          registerCode: "31104205002020103322",
          handNewspaperNum: 0,
          handNewspaperSum: 126,
          detectorNum: 0,
          detectorSum: 176,
        },
        {
          title: "4#主楼消防电梯",
          registerCode: "31104205002020103318",
          handNewspaperNum: 0,
          handNewspaperSum: 126,
          detectorNum: 0,
          detectorSum: 176,
        },
        {
          title: "小裙楼右侧电梯",
          registerCode: "31104205002020103324",
          handNewspaperNum: 0,
          handNewspaperSum: 126,
          detectorNum: 0,
          detectorSum: 176,
        },
        {
          title: "小裙楼左侧电梯",
          registerCode: "31104205002020103325",
          handNewspaperNum: 0,
          handNewspaperSum: 126,
          detectorNum: 0,
          detectorSum: 176,
        }
      ],
      deviceEui: null,
      elevatorDialogVisible: false,
      registerCode: null,
      title: null// 弹框title
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 仅在渲染整个视图之后运行的代码

    })
  },
  created() {

  },
  methods: {

    go(registerCode, title) {
      this.elevatorDialogVisible = true
      this.title = title
      this.registerCode = registerCode
      //   this.$router.push({ path: '/fireFightingSystem/index', query: { index: index + '' } })
    },
    //地图放大缩小
    rollImg(event) {
      let zoom = parseInt(this.mapZoom) || 100;
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom
            wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动
        */
      let delta = event.wheelDelta
      if (!event.wheelDelta) {
        delta = event.detail
        zoom -= delta / 3 * 10;
      } else {
        zoom += delta / 12;
      }
      /* 最小范围 和 最大范围 的图片缩放尺度 */
      if (zoom >= this.minZoom && zoom < this.maxZoom) {
        this.mapZoom = zoom;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.app-container .map {
  overflow: hidden;
  position: relative;
  .tip {
    position: absolute;
    top: 0;
    cursor: pointer;
    border-radius: 10px;
    text-align: center;
    color: #333;
    font-weight: 500;
    font-size: 14px;
    &:nth-child(2) {
      top: 554px;
      left: 655px;
    }
    &:nth-child(3) {
      top: 554px;
      left: 624px;
      .bubble_box {
        left: -75px;
        .bubble_bot_cor {
          left: 78px;
        }
      }
    }
    &:nth-child(4) {
      top: 640px;
      left: 794px;
    }
    &:nth-child(5) {
      top: 640px;
      left: 824px;
    }
    &:nth-child(6) {
      top: 680px;
      left: 794px;
    }
    &:nth-child(7) {
      top: 680px;
      left: 824px;
    }
    &:nth-child(8) {
      top: 635px;
      left: 1032px;
    }
    &:nth-child(9) {
      top: 566px;
      left: 1185px;
    }
    &:nth-child(10) {
      top: 596px;
      left: 1192px;
    }
    &:nth-child(11) {
      top: 20px;
      left: 680px;
    }
  }
}
.bubble_bot_cor {
  display: block;
  width: 10px;
  height: 7px;
  background: url("../../../../assets/images/cir.png");
  // background: url("../../../../../../assets/images/cir.png");
  position: absolute;
  bottom: -6px;
  left: 12px;
}
.bubble_box {
  font-size: 12px;
  line-height: 12px;
  padding: 0px 5px;
  background: rgb(61, 75, 92);
  position: absolute;
  border-radius: 6px 6px;
  /*border: 1px solid rgba(230,237,244,.8);*/
  left: -7px;
  bottom: 45px;
  color: #e6edf4;
  white-space: nowrap;
}

.bubble_box span {
  margin-left: 3px;
}

.v-tooltip {
  position: absolute;
  background: #303133;
  color: #fff;
  transform-origin: center bottom;
  z-index: 2101;
  border-radius: 4px;
  padding: 10px;
  font-size: 12px;
  line-height: 1.2;
  min-width: 10px;
  white-space: nowrap;
  top: -42px;
  display: none;
  transition: all 0.5s;
  .el-icon-caret-bottom {
    position: absolute;
    top: 25px;
    left: 2px;
    font-size: 24px;
    color: #303133;
  }
}
.tip:hover {
  .v-tooltip {
    display: block;
    transition: all 0.5s;
  }
}
</style>